// extracted by mini-css-extract-plugin
export default {"listScopedCommand":"ListItems-module__listScopedCommand--yfPc2","tabsContainer":"ListItems-module__tabsContainer--qrUH2","loading":"ListItems-module__loading--jvxma"};